/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
import { ActionTree } from 'vuex';
import * as types from '@/store/types';
import { handleErrorMessage, handleInfoMessage } from '@/store/handleCatchError';
import { logging } from '@/scripts/debugger';
import { OK, SERVICES } from '@/middlewares/httpClient';
import { GetPlatformConfig, PutPlatformConfig } from './apis';
import { RootState } from '../models';
import { PlatformConfig } from './models';

const log = (message: string) => {
  logging('VUEX/flow/actions', message);
};

const service : string = SERVICES.get('userservice');

export const actions: ActionTree<PlatformConfig, RootState> = {
  // FETCH PLATFORM CONFIG
  async [types.FETCH_PLATFORM_CONFIG]({ commit, dispatch }): Promise<any> {
    log('FETCH_PLATFORM_CONFIG is called');

    await GetPlatformConfig()
      .then(({ data }) => {
        const platformConfig: PlatformConfig = data;

        commit(types.MUTATE_PLATFORM_CONFIG, platformConfig);
      })
      .catch((err) => handleErrorMessage(err, dispatch, service));
  },
  // UPDATE_PLATFORM_CONFIG
  async [types.UPDATE_PLATFORM_CONFIG]({ commit, dispatch }, platformConfig: PlatformConfig):
    Promise<any> {
    await PutPlatformConfig(platformConfig)
      .then(({ status, data }) => {
        if (status === OK) {
          const config: PlatformConfig = data;
          commit(types.MUTATE_PLATFORM_CONFIG, config);
          handleInfoMessage('platform_updated', dispatch);
        }
      })
      .catch((err) => {
        handleErrorMessage(err, dispatch, service);
      });
  },
};
